import { ScrollArea } from "@base-ui/react/scroll-area"
import React from "react"
import { useTranslation } from "react-i18next"

import classNames from "classnames"

import { IconSize } from "shared/types/Icon"
import { Button, ButtonVariant } from "shared/ui/buttons/Button"
import { Icon } from "shared/ui/icon/Icon"
import { IconName } from "shared/ui/icon/__generated__/IconName"

import { LogoSliderProps } from "../LogoSlider"
import "../styles/_logo-slider.scss"

export interface LogoSliderViewModel extends LogoSliderProps {
  scrollContainer: HTMLDivElement | null
  setScrollContainer: (element: HTMLDivElement | null) => void
  requiresScroll: boolean
  onScrollNext: () => void
  onScrollPrev: () => void
}

export const LogoSliderView = React.memo(
  ({
    setScrollContainer,
    requiresScroll,
    onScrollNext,
    onScrollPrev,
    children,
    className
  }: LogoSliderViewModel) => {
    const { t } = useTranslation()

    return (
      <div className={classNames("logo-slider", className)}>
        <div className="logo-slider__button-container">
          <Button
            variant={ButtonVariant.TERTIARY}
            className={classNames(
              "btn--borderless",
              "logo-slider__control",
              "logo-slider__control--previous",
              { "d-none": !requiresScroll }
            )}
            onClick={onScrollPrev}
            aria-label={t("General.Previous")}
          >
            <Icon name={IconName.SMALL_CARET_LEFT} size={IconSize.XS} />
          </Button>
        </div>

        <ScrollArea.Root className="scroll-area scroll-area--horizontal shadow-s">
          <ScrollArea.Viewport
            ref={setScrollContainer}
            className="scroll-area__viewport"
          >
            <ScrollArea.Content className="scroll-area__content logo-slider__scroll-area">
              {children}
            </ScrollArea.Content>
          </ScrollArea.Viewport>
        </ScrollArea.Root>

        <div className="logo-slider__button-container">
          <Button
            variant={ButtonVariant.TERTIARY}
            className={classNames(
              "btn--borderless",
              "logo-slider__control",
              "logo-slider__control--next",
              { "d-none": !requiresScroll }
            )}
            onClick={onScrollNext}
            aria-label={t("General.Next")}
          >
            <Icon name={IconName.SMALL_CARET_RIGHT} size={IconSize.XS} />
          </Button>
        </div>
      </div>
    )
  }
)
